// extracted by mini-css-extract-plugin
module.exports = {"Inlay":"Inlay_Inlay_2sMAv","Inlay_trans_enter":"Inlay_Inlay_trans_enter_3r47M","Inlay_trans_leaveTo":"Inlay_Inlay_trans_leaveTo_sx0uB"};